import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-applicant-agent.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-applicant-agent.component.scss?ngResource";
import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { ApplicationSearchConstants } from "../application-search-constants";
import { AppControllerService } from "../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
import { applicationsFormGroup } from "../../../../store/actions/tab-applications.actions";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
let SearchApplicantAgentComponent = class SearchApplicantAgentComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    _destroy$ = new Subject();
    applicantAgentNameLabel = ApplicationSearchConstants.FORM_CONTROLS.nameLabel;
    applicantAgentSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.surnameLabel;
    applicantAgentNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    applicantAgentSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    applicantAgentOrganisationLabel = ApplicationSearchConstants.FORM_CONTROLS.organisationLabel;
    applicantAgentOrganisationFormControl = ApplicationSearchConstants.FORM_CONTROLS.organisationFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    applicantAgentForm;
    tabChanged;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val !== null && this.tabChanged) {
                this.applicantAgentForm = val;
            }
        });
        this.tabChanged = false;
        const agentName = this.applicantAgentForm.get(this.applicantAgentNameFormControl).value;
        const agentSurname = this.applicantAgentForm.get(this.applicantAgentSurnameFormControl).value;
        const agentOrganisation = this.applicantAgentForm.get(this.applicantAgentOrganisationFormControl).value;
        if (!this.tabChanged) {
            this.applicationSearchCallback(this.applicationSearchService.searchByApplicantAgent(agentName, agentSurname, agentOrganisation, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
            this.store.dispatch(applicationsFormGroup({ value: this.applicantAgentForm }));
        }
    }
    setUpForm() {
        this.applicantAgentForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            organisationFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
};
SearchApplicantAgentComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-applicant-agent",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchApplicantAgentComponent);
export { SearchApplicantAgentComponent };
